// extracted by mini-css-extract-plugin
export default {"container":"product-image__container___5QXWn"};